import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const EstimatedMonthlyBudget = ({
  classes, i18n, value, selectedCurrencyText,
}) => (
  <div className={classNames('budget-monthly', classes.budgetMonthly)}>
    {i18n.getString(
          _TL_('Estimated monthly budget: {{value}} {{currency}}'),
          {
            value,
            currency: selectedCurrencyText,
          }
        )}
  </div>
);

EstimatedMonthlyBudget.propTypes = {
  classes: PropTypes.shape({
    budgetMonthly: PropTypes.string,
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  value: PropTypes.number.isRequired,
  selectedCurrencyText: PropTypes.string.isRequired,
};

